<template>
  <div class="text-center">
    <v-overlay :value="overlay" z-index="10" opacity="1">
      <v-row class="fill-height" align-content="center" justify="center">
        <v-col class="text-subtitle-1 text-center" cols="12">
          <v-avatar size="100">
            <v-img
              :aspect-ratio="1 / 1"
              :lazy-src="require('@/assets/namya_logo.png')"
              :src="customers.image"
              alt=""
            />
          </v-avatar>
          <v-card-text class="mt-4">{{ customers.name }}</v-card-text>
        </v-col>
        <v-col cols="12" class="ma-0">
          <v-progress-linear
            color="success accent-4"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </v-col>
      </v-row>
    </v-overlay>
  </div>
</template>

<script>
export default {
  props: {
    overlay: true,
    customers: {},
  },
  data() {
    return {
      // overlay: false,
      location: window.document.location.host.replace("www.", ""),
    };
  },
  watch: {},
  methods: {
    loading() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$props.overlay = false;
        }, 4000);
      });
    },
  },
  mounted() {
    this.loading();
  },
  updated() {
    this.loading();
  },
};
</script>

<style></style>

<!-- <template>
  <div class="text-center">
    <v-overlay :value="overlay" z-index="10" opacity="1">
      <v-row class="fill-height" align-content="center" justify="center">
        <v-col class="text-subtitle-1 text-center" cols="12">
          <v-avatar size="90">
            <v-img
              :aspect-ratio="1 / 1"
              :src="require('@/assets/namya_logo.png')"
              alt=""
            />
          </v-avatar>
          <v-card-text>{{ customers.name }}</v-card-text>
        </v-col>
        <v-col cols="12">
          <v-progress-linear
            color="success"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </v-col>
      </v-row>
    </v-overlay>
  </div>
</template>

<script>
export default {
  props: {
    overlay: true,
    customers: {},
  },
  data() {
    return {
      // overlay: false,
      location: window.document.location.host.replace("www.", ""),
    };
  },
  watch: {},
  methods: {
    loading() {
      this.$props.overlay = false;
    },
  },
  created() {
    setTimeout(() => {
      this.loading();
    }, 4800);
  },
  updated() {
    this.loading();
  },
};
</script>

<style></style> -->
